import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'EquipmentMaster',
  //   description: 'description of EquipmentMaster',
  //   url: '/equipment-master',
  // },
];

export default help;
